module.exports = __webpack_public_path__ + "media/images/weather/168_day-353acfb50351637b62f89762e0b73a4e.png";